// Chat composer + slash-command picker (WEB-8002). Composed by
// workspaceStyles.ts at the sections' original positions — order is cascade.
export const chatComposer = `
/* ===== Composer ===== */
.ws-agent-created-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  margin: 0 auto 8px;
  max-width: 880px;
  width: 100%;
  background: var(--ws-bg);
  border: 1px solid var(--ws-border);
  border-radius: 10px;
}
.ws-agent-created-banner strong { font-weight: 600; }
.ws-btn-sm { padding: 6px 12px; font-size: 13px; gap: 4px; }

.ws-composer-wrap {
  position: relative;
  padding: 16px 32px 24px;
  background: var(--ws-bg);
  margin: 0 auto;
  max-width: calc(880px + 64px); /* 880 content + 32px gutter each side */
  width: 100%;
  flex-shrink: 0;
}
.ws-composer {
  display: flex; align-items: center;
  padding: 6px 6px 6px 14px;
  background: var(--ws-panel);
  border: 1px solid var(--ws-line-2);
  border-radius: 999px;
  box-shadow: var(--ws-shadow-md);
  gap: 8px;
}
.ws-composer:focus-within { border-color: var(--ws-ink-3); box-shadow: var(--ws-shadow-lg); }
.ws-composer input {
  flex: 1;
  border: 0; outline: none; background: transparent;
  font-size: 14.5px;
  padding: 8px 0;
  color: var(--ws-ink);
  font-family: var(--ws-sans);
}
.ws-composer-tool {
  border: 0; background: transparent;
  color: var(--ws-ink-4);
  padding: 7px;
  border-radius: 50%;
  display: grid; place-items: center;
  cursor: pointer;
}
.ws-composer-tool:hover { color: var(--ws-ink-2); background: var(--ws-soft); }
.ws-composer-route {
  display: flex; align-items: center; gap: 6px;
  font-size: 11.5px; color: var(--ws-ink-4);
  border-left: 1px solid var(--ws-line);
  padding-left: 10px;
  margin-right: 4px;
  white-space: nowrap;
}
.ws-composer-send {
  width: 34px; height: 34px;
  border-radius: 50%;
  border: 0;
  background: var(--ws-soft);
  color: var(--ws-ink-5);
  display: grid; place-items: center;
  transition: all 0.15s;
  cursor: pointer;
  flex-shrink: 0;
}
.ws-composer-send.ws-on { background: var(--ws-ink); color: #e8f9f8; }
.ws-composer-hint {
  font-size: 11.5px; color: var(--ws-ink-4);
  text-align: center;
  margin-top: 10px;
}
.ws-agent-chip {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 3px 9px 3px 4px;
  border-radius: 999px;
  background: white;
  border: none;
  font-size: 12px;
  font-weight: 500;
  color: var(--ws-ink-2);
}
.ws-trace-ev-body .ws-agent-chip {
  border: none; background: transparent; padding: 0; gap: 4px;
}
.ws-agent-chip .ws-sw {
  width: 16px; height: 16px; border-radius: 5px;
  display: grid; place-items: center;
  color: white; font-family: var(--ws-serif); font-size: 10px; font-weight: 700;
}
`;

export const chatSlashCommandPicker = `
/* ===== Slash command picker ===== */
.ws-slash-picker {
  position: absolute; bottom: calc(100% + 6px); left: 0; right: 0;
  background: var(--ws-panel); border: 1px solid var(--ws-line);
  border-radius: var(--ws-r-md); box-shadow: var(--ws-shadow-md);
  z-index: 30; overflow: hidden;
}
.ws-slash-item {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 12px; font-size: 13px; cursor: pointer;
  border-bottom: 1px solid var(--ws-line);
}
.ws-slash-item:last-child { border-bottom: 0; }
.ws-slash-item.active { background: var(--ws-hover); }
.ws-slash-cmd {
  font-family: var(--ws-mono); font-size: 12px;
  color: var(--ws-ink-3); background: var(--ws-soft);
  padding: 1px 6px; border-radius: 3px;
}
.ws-slash-desc { color: var(--ws-ink-3); }
`;
